import { MapboxPlaceObject } from '../../types/mapbox/MapboxPlaceObject';
import { MapboxPlaceType } from '../../types/MapboxPlaceType';

const ADDRESS_ACCEPTABLE_ACCURACY_TYPES = ['rooftop', 'point'];

export function isAddress(mapboxPlaceObject: MapboxPlaceObject) {
  return (
    mapboxPlaceObject.place_type.some(x => x === MapboxPlaceType.Address) &&
    ADDRESS_ACCEPTABLE_ACCURACY_TYPES.includes(
      mapboxPlaceObject.properties.accuracy,
    )
  );
}
